import { elevatorQuote, type GameSnapshot } from '../engine/casino';
import { floorDef, FLOORS } from '../engine/floors';
import { money } from '../format';
import type { GameActions } from '../useGame';
import { MenuFrame } from './MenuFrame';

export function Elevator({ snapshot, actions }: { snapshot: GameSnapshot; actions: GameActions }) {
  const run = snapshot.run!;
  const quote = elevatorQuote(run);
  const here = floorDef(run.floor);

  if (!quote) {
    return (
      <MenuFrame snapshot={snapshot} actions={actions} title="Elevator" backLabel="Back to the floor">
        <p className="menu-intro">This is the top floor. The only thing left to buy is the casino itself, in the Gift Shop.</p>
      </MenuFrame>
    );
  }

  const tone = quote.blocked ? 'blocked' : quote.warn ? 'warn' : 'ok';
  return (
    <MenuFrame
      snapshot={snapshot}
      actions={actions}
      title="Elevator"
      backLabel="Back to the floor"
      footer={
        <div className="control-buttons" style={{ ['--count' as string]: 2 }}>
          <button className="btn btn-secondary" onClick={() => actions.ride(false)}>Stay</button>
          <button className="btn btn-primary" disabled={quote.blocked} onClick={() => actions.ride(true)}>Ride up · {money(quote.cost)}</button>
        </div>
      }
    >
      <section className="elevator">
        <ol className="floor-dial" aria-label="Floors">
          {[...FLOORS].reverse().map((f) => (
            <li key={f.id} className={f.id === quote.to.id ? 'next' : f.id === run.floor ? 'here' : f.id < run.floor ? 'below' : ''}>
              <span className="dial-num">{f.id}</span>
              <span className="dial-name">{f.name}</span>
              {f.id === run.floor && <span className="dial-tag">You</span>}
              {f.id === quote.to.id && <span className="dial-tag">Next</span>}
            </li>
          ))}
        </ol>
        <div className="block paper quote">
          <div className="quote-row"><span>Fare to the {quote.to.name}</span><strong>{money(quote.cost)}</strong></div>
          <div className="quote-row"><span>You’d arrive with</span><strong>{money(Math.max(0, quote.after))}</strong></div>
          <div className="quote-row"><span>A usual bet up there</span><strong>{money(quote.typicalUp)}</strong></div>
          <div className="quote-row"><span>Runway</span><strong>{quote.runway} {quote.runway === 1 ? 'bet' : 'bets'}</strong></div>
          <p className={`quote-note ${tone}`}>
            {quote.blocked
              ? `You couldn't place a single bet up there (the cheapest is ${money(quote.cheapestUp)}). Win more on the ${here.name} first.`
              : quote.warn
                ? `Thin: under 10 bets of runway. The elevator only goes up, so a cold streak upstairs ends the run.`
                : 'Plenty of runway. Every bet up there is bigger, and so are the wins.'}
          </p>
        </div>
      </section>
    </MenuFrame>
  );
}
